export const OFFLINE_BACKUP_QUIZ = {
  title: 'AI Mock Competency Assessment: Portfolio & Resume',
  source: 'fallback',
  fallback_reason: 'client_offline_backup',
  project_count: 2,
  question_count: 5,
  questions: [
    {
      id: 1,
      project_reference: 'System Design',
      question:
        'When scaling a full-stack application to serve high read traffic, which caching strategy best prevents database bottlenecks?',
      options: [
        'Cache-Aside (Lazy Loading) with Redis or Memcached',
        'Write-Through caching directly into local disk storage',
        'Disabling connection pooling to isolate queries',
        'Increasing client-side polling frequency to 10ms',
      ],
      correct_answer: 0,
      explanation:
        'Cache-Aside is standard for read-heavy workloads, only querying the database when data is missing from the cache.',
    },
    {
      id: 2,
      project_reference: 'Backend Engineering',
      question:
        "What is the primary security benefit of using JWTs (JSON Web Tokens) over server-side session storage?",
      options: [
        'Stateless authentication across distributed services without central database lookups',
        'Automatic encryption of all client-side network payloads by default',
        'Infinite token validity requiring zero expiration handling',
        'Eliminating the need for HTTPS encryption over network transport',
      ],
      correct_answer: 0,
      explanation:
        'JWTs are self-contained and stateless, allowing distributed verification without querying a central session database.',
    },
    {
      id: 3,
      project_reference: 'Database Optimization',
      question:
        'Which algorithmic complexity is achieved when indexing a primary key for lookups in a B-Tree relational database?',
      options: ['O(log N) logarithmic time', 'O(1) constant time', 'O(N) linear time', 'O(N^2) quadratic time'],
      correct_answer: 0,
      explanation: 'B-Tree indexes structure database records to keep lookup depth logarithmic.',
    },
    {
      id: 4,
      project_reference: 'Core Engineering',
      question:
        'In a React application, what is the correct way to prevent an expensive calculation from re-running on every render?',
      options: [
        'Memoize the computed value with useMemo when its dependencies are unchanged',
        'Mutate the component state directly inside the render body',
        'Store the value in a module-level global shared across all components',
        'Move the calculation into the JSX return statement',
      ],
      correct_answer: 0,
      explanation:
        'useMemo caches the result between renders and only recalculates when the dependency list changes.',
    },
    {
      id: 5,
      project_reference: 'API Design',
      question:
        'Which HTTP status code should an API return when a client submits a syntactically invalid request body?',
      options: ['400 Bad Request', '401 Unauthorized', '404 Not Found', '500 Internal Server Error'],
      correct_answer: 0,
      explanation:
        '400 signals that the request itself is malformed, distinct from auth failures (401/403) and server faults (500).',
    },
  ],
};
